export const URL_COPYRIGHT = "https://hallow.com/copyright";
